module.exports = __webpack_public_path__ + "img/icon_youshi05.1ef90703.png";